import { LOAD_PROJECT, FETCH_LINKS, CREATE_LINK, UPDATE_LINK, DESTROY_LINK, REMOVE_LINK_PIXEL_SET, LOGOUT } from '../actions/actionTypes.js';
import { findIndex } from 'lodash';


const initialState = []

export const linksList = (state = initialState, action) => {
  let idx;
  switch (action.type) {
    case FETCH_LINKS.SUCCESS:
      return action.payload.links || initialState //keyBy(action.payload.data['links'] || [], 'id');
    case LOAD_PROJECT.START:
    case FETCH_LINKS.UNLOAD:
      return initialState;
    case CREATE_LINK.SUCCESS:
      idx = findIndex(state, {id: action.payload.id})
      if (idx >= 0 || !!action.payload.parent_id === true)
        return state;
      
      return [
        action.payload,
        ...state
      ];
    case UPDATE_LINK.SUCCESS:
    case REMOVE_LINK_PIXEL_SET.SUCCESS:
      idx = findIndex(state, {id: action.payload.id})
      if (idx < 0 || !!action.payload.parent_id === true)
        return state;
      
      return [
        ...state.slice(0, idx),
        action.payload,
        ...state.slice(idx + 1)
      ];
    case DESTROY_LINK.SUCCESS:
      idx = findIndex(state, {id: action.payload.id});
      if (idx < 0)
        return state;
      
      return [
        ...state.slice(0, idx),
        ...state.slice(idx + 1)
      ];
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/linksList.js